import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { convertToRupiah } from '../../../utils';

export default class BankTransferInstructions extends Component{
  constructor(props){
    super(props);
    this.state={
      account_number: '198 998 8059',
      account_name: 'PT Internasional Citra Kencana'
    }

}

  render(){
    const { totalAmount } = this.props;
    return(
      <div className="instruction-content">
        <div className="title-instruction">
          <p><b>Instructions</b></p>
        </div>
        <div className="instruction-topup">
          <ul>
            <li>
              Visit any ATM machine or any mBanking app on your smartphone
            </li>
            <li>
              Select TRANSFER<br/>
              <i>If you are not using BCA, then select TRANSFER ANTAR BANK, and input BCA bank code.</i>
            </li>
            <li>
              Input <span className="bold">{this.state.account_number} </span><br/>
              <i>under {this.state.account_name}</i>
            </li>
            <li>
            Input <span className="bold">{convertToRupiah(parseInt(totalAmount))}</span> as the sum of the transfer
            </li>
            <li>
            Input <span className="bold">KICKWALLET-(email)</span> on the Note / Berita Acara.
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
